export const startWogaaTransactionalService = (trackingId: string, customTransactionId: string = null) => {
  if (customTransactionId) {
    window?.wogaaCustom?.startTransactionalService(trackingId, { uniqueTransactionId: customTransactionId });
  } else {
    window?.wogaaCustom?.startTransactionalService(trackingId);
  }
};

export const completeWogaaTransactionalService = (trackingId: string, customTransactionId: string = null) => {
  if (customTransactionId) {
    window?.wogaaCustom?.completeTransactionalService(trackingId, { uniqueTransactionId: customTransactionId });
  } else {
    window?.wogaaCustom?.completeTransactionalService(trackingId);
  }
};

export const addWogaaMetaData = (metaData: string) => {
  window?.wogaaCustom?.addMeta({ agencyTxnId: metaData });
};
